import React from "react";
import "../Style/Component/Ridedetails.css";
import calender from "../Assets/Detailstable/calender.svg";
import clock from "../Assets/Detailstable/clock.svg";
import yellowstar from "../Assets/Detailstable/yellowstar.svg";
import greystar from "../Assets/Detailstable/greystar.svg";
import { useNavigate } from "react-router-dom";
const Ridedetailcard = (ride) => {
  console.log(ride, "RIDE");
  const getTime = (isoDate) => {
    const date = new Date(isoDate);

    return date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };
  const navigate = useNavigate();

  const getCustomDate = (isoDate) => {
    const date = new Date(isoDate);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${day}-${month}-${year}`;
  };

  return (
    <div
      className="ridedetailcard"
      onClick={() => navigate(`/admin/ridestrack/${ride?.ride?._id}`)}
    >
      <span
        className={`ridestatus${
          ride?.ride?.status.toLowerCase() === "cancelled" ? "cancelled" : ""
        }`}
      >
        {ride?.ride?.status}
      </span>
      <div className="rideadd">
        <div className="ridefrom">
          <span className="rideaddhead">From</span>
          <span className="rideaddbody">{ride?.ride?.pickup?.address}</span>
        </div>
        <div className="rideto">
          <span className="rideaddhead">To</span>
          <span className="rideaddbody">{ride?.ride?.drop?.address}</span>
        </div>
      </div>
      <div className="riderdriver">
        <div className="ridetimingstatus">
          <span>
            <b
              style={{
                color: "rgba(54, 54, 54, 0.92)",
                fontSize: "16px",
                marginRight: "4px",
                fontWeight: "500",
              }}
            >
              User name:
            </b>
            {ride?.ride?.userId?.name}
          </span>
          {ride?.ride?.status === "COMPLETED" && (
            <span>
              <b
                style={{
                  color: "rgba(54, 54, 54, 0.92)",
                  fontSize: "16px",
                  marginRight: "4px",
                  fontWeight: "500",
                }}
              >
                Price:
              </b>
              {ride?.ride?.price}
            </span>
          )}
        </div>

        <div className="ridetiming">
          <div className="timing">
            <img src={calender} />
            <span style={{ marginLeft: "4px" }}>
              {getCustomDate(ride?.ride?.createdAt)}
            </span>
          </div>
          <div className="timing">
            <img src={clock} />
            {ride?.ride?.statusTimeline?.[4]?.timestamp && (
              <span style={{ marginLeft: "4px" }}>
                {getTime(ride?.ride?.statusTimeline?.[0]?.timestamp)}-
                {getTime(ride?.ride?.statusTimeline?.[4]?.timestamp)}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="ridereview">
        <span className="head">Review</span>
        <div className="starrating">
          {[1, 2, 3, 4, 5].map((star) => (
            <img
              key={star}
              src={
                star <= (ride?.ride?.feedback?.rating || 0)
                  ? yellowstar
                  : greystar
              }
              alt="star"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Ridedetailcard;
